module.exports = __webpack_public_path__ + "static/media/soundConst.9138f389.mp3";